module.exports = __webpack_public_path__ + "img/73.b8df629.png";